
import platform from '../util/platform';

var result = !platform.is.WEBKIT;

export default function () {
  return result;
}
//# sourceMappingURL=focus-in-zero-dimension-object.js.map